import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './FeedCard.module.scss'
import {Avatar, Card, Dropdown, Menu, notification, Popover} from "antd";
import {CommentOutlined, MoreOutlined, TagOutlined} from "@ant-design/icons";
import {isImgType} from "../../../service/files.util";
import {getUrl} from "../../../service/files.service";
import CoverPreviewContainer from "../Cover/CoverPreviewContainer";
import { allPrivacyOption, coversGrid, expURL, maxCoverSize } from "../../../constants/Feed";
import { useTranslation } from "react-i18next";
import heartLogo from "../../shared/Heart/like.json";
import linkifyHtml from 'linkifyjs/html'
//@ts-ignore
import AutoLinkText from "react-autolink-text2";
// import Lottie from "react-lottie";
import Lottie from "lottie-react";
import AvatarGroup from "@atlaskit/avatar-group";
import { getUserData } from "../../../service/auth.service";
import useFetch, { CachePolicies } from "use-http";
import { usePrevious } from "../../../hooks/usePrevious";
import useLinkCover from "../../../hooks/useLinkCover";
import _ from "lodash";
import PreviewPostLink from "../../../pages/Home/Post/PreviewPostLink";
import bookMarkAnimate from "../../shared/BookMark/book-mark2.json";
import editImg from "../../../assets/png/newIcon/Home Feed/Edit post/Edit post.png";
import deleteImg from "../../../assets/png/newIcon/Home Feed/Edit post/Delete.png";
import exclamationImg from "../../../assets/png/exclamation_2.png";
import { useLocation } from "react-router-dom";
import CenterConfirmModal from "../../shared/Modal/CenterConfirmModal";
import UIModalReportPost from "../../../pages/Home/Post/component/UIModalReportPost";
import useTimeConvert from "../../../hooks/useTimeConvert";
import {ProfilePopover} from "../../Popover";
import { FeedParamList } from 'src/models/Feeds';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {likeFeed, publishFeed} from "../../../service/feed.sevice";
import {deleteFeed} from "../../../api/feeds";

interface FeedProps {
    id: string
    avatarURL: string
    name: string
    createdAt: string
    title: string
    likes: any[]
    isLike: boolean
    isPin: boolean
    isMyPaperPin: boolean
    totalComments: number
    ownerId: string
    owner: string
    privacy: any,
    mentions: any,
    categories: any,
    onEditPost: (data: any) => void
    onDelete: (feedId: string) => void
    covers?: any[]
    content?: any
    contentStyle?: string
    onOpenComments: (feedId: string) => void
    onOpenOwnerProfile: (userId: string) => void
    canUsePin: boolean
    isPinType: boolean
    params?: any
}

const URLFileService = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER;
const regexURL = new RegExp(expURL);

type NotificationType = 'success' | 'info' | 'warning' | 'error';

const openNotificationWithIcon = (type: NotificationType, message: string, description: string) => {
    notification[type]({
        message: message,
        description: description,
    });
};

export const FeedCard: React.FunctionComponent<FeedProps> = (props) => {
    const {t} = useTranslation();
    const location = useLocation();
    const postTime = useTimeConvert(props.createdAt);

    const [formatCovers, setFormatCovers] = useState<any[]>([]);
    const [readMore, setReadMore] = useState<boolean>();
    const [isLike, setIsLike] = useState<boolean>(props.isLike);
    const [isPin, setIsPin] = useState<boolean>(props.isPin);
    const [isPaperPin, setIsPaperPin] = useState<boolean>(props.isMyPaperPin);
    const [likeUsers, setLikeUsers] = useState<any[]>([]);

    const [showDeletePostModal, setShowDeletePostModal] = useState<boolean>(false);
    const [showProfileModal, setShowProfileModal] = useState<boolean>(false);
    const [showReportModal, setShowReportModal] = useState<boolean>(false);

    const [openComments, setOpenComments] = useState<boolean>(false);
    const [openPopover, setOpenPopover] = useState<boolean>(false);

    const titleLink = useLinkCover(props.title);
    const contentLink = useLinkCover(props.content);

    const prevIsPin: boolean = usePrevious(isPin);
    const prevIsLike: boolean = usePrevious(isLike);

    const innerContentRef = useRef<HTMLDivElement>(null);
    const queryClient = useQueryClient();

    const likeMutation = useMutation(likeFeed, {
        onMutate: (variables) => {
        },
        onSuccess: (data, variables, context) => {
        },
        onError: (error, variables, context) => {
            openNotificationWithIcon('error', t("Something wrong"), t("Can't like post"));
        },
        onSettled: (data, error, newPost) => {
            setShowDeletePostModal(false);
        },
    })

    const deleteMutation = useMutation(deleteFeed, {
        onMutate: (variables) => {
            // console.log("onMutate", variables);
        },
        onSuccess: (data, variables, context) => {
            openNotificationWithIcon('success', t("Successfully delete post"), t(""));
        },
        onError: (error, variables, context) => {
            // console.log("onError");
            // onError()
            openNotificationWithIcon('error', t("Something wrong"), t("Can't delete post"));
        },
        onSettled: (data, error, newPost) => {
            queryClient.refetchQueries(['feeds', props.params])
            setShowDeletePostModal(false);
        },
    })

    const likeAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/feeds/like",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const openGraphAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/crawler/og",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const favAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/feeds/pin",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    // const deleteFeedAPI = useFetch(
    //     window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/feeds/delete/${props.id}`,
    //     {
    //         cachePolicy: CachePolicies.NO_CACHE,
    //     }
    // );

    const paperPinAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/feeds/paperpin",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const getPreviewPeopleLike = useCallback(() => {
        let _likePeople: any = [];
        // const peopleCount = props.likes?.length > 4 ? 3 : props.likes?.length;

        for (let index = 0; index < props.likes?.length; index++) {
            _likePeople.push(props.likes[index]?.user);
        }
        return _likePeople;
    }, [props.likes]);

    const getImageURL = useCallback((cover: any) => {
        if (cover.coverKind === "video") {
            return `${URLFileService}/downloadFile?fileId=${cover.imageID}`;
        } else {
            if (cover.coverLink) {
                return cover.coverLink;
            } else {
                return `${URLFileService}/downloadFile?fileId=${cover.imageID}`;
            }
            //+ "&size=300"
        }
    }, []);

    const getTagString = useCallback((mentions: any) => {
        const tagStringArr = mentions.map((item: any, index: number) => {
            let comma = "";
            if ((item?.user || item?.group) && index < mentions?.length - 1) {
                comma = " , ";
            }

            if (!item.user && !item.group) {
                if (index < mentions?.length - 1) {
                    comma = " , ";
                }

                if (item?.type === "user") {
                    return comma + "Unknown user";
                } else if (item?.type === "group") {
                    return comma + "Unknown group";
                }
            }

            return item?.type === "user"
                ? item?.user?.firstname +
                (item?.user?.lastname ? " " + item?.user?.lastname : "") +
                comma
                : item?.group?.name
                    ? item?.group?.name + comma
                    : "private group";
        });

        return tagStringArr.join("");
    }, [])

    const checkRotation = useCallback(async (url: string) => {
        const img = new Image();
        img.src = url;
        img.crossOrigin = "anonymous";
        let rotationValue: any = "something";

        const rotation = {
            horizontal: "horizontal",
            vertical: "vertical",
            default: "default",
        };

        await img.decode();

        if (img.width > img.height) {
            rotationValue =
                img.height < img.width * 0.75 ? rotation.horizontal : rotation.default;
        } else if (img.height > img.width) {
            rotationValue =
                img.width < img.height * 0.75 ? rotation.vertical : rotation.default;
        } else {
            rotationValue = rotation.default;
        }

        return rotationValue;
    }, [])

    // const checkRotation = async (url: string) => {
    //     const img = new Image();
    //     img.src = url;
    //     img.crossOrigin = "anonymous";
    //     let rotationValue: any = "something";
    //
    //     const rotation = {
    //         horizontal: "horizontal",
    //         vertical: "vertical",
    //         default: "default",
    //     };
    //
    //     await img.decode();
    //
    //     if (img.width > img.height) {
    //         rotationValue =
    //             img.height < img.width * 0.75 ? rotation.horizontal : rotation.default;
    //     } else if (img.height > img.width) {
    //         rotationValue =
    //             img.width < img.height * 0.75 ? rotation.vertical : rotation.default;
    //     } else {
    //         rotationValue = rotation.default;
    //     }
    //
    //     return rotationValue;
    // };

    const getCoverType = useCallback((coverKind: any) => {
        if (coverKind === "image") {
            return "image";
        } else if (isImgType(coverKind)) {
            return "image";
        }
        return coverKind;
    }, [])

    // const getCoverType = (coverKind: any) => {
    //     if (coverKind === "image") {
    //         return "image";
    //     } else if (isImgType(coverKind)) {
    //         return "image";
    //     }
    //     return coverKind;
    // };

    const handleClickFooter = useCallback(() => {
        props.onOpenComments(props.id)
    }, [])

    const formatCoversData = useCallback(async () => {
        if (!props.covers) return;
        try {
            const newCovers = await Promise.all(
                props.covers.map(async (cover: any) => {
                    let imgURL = getImageURL(cover);
                    const coverTitle = cover.title.split(".");
                    let coverExtension = coverTitle[coverTitle.length - 1];
                    if (cover?.coverKind === "image" || isImgType(cover?.coverKind))
                        imgURL = await getUrl(imgURL, cover.imageID, 1024, "post");
                    return {
                        coverLink: imgURL,
                        coverType: getCoverType(cover?.coverKind),
                        rotation:
                            cover?.coverKind === "image" || isImgType(cover?.coverKind)
                                ? await checkRotation(imgURL)
                                : "default",
                        imageID: cover.imageID,
                        title: cover.title,
                        coverKind: cover.coverKind,
                        id: cover.id,
                        coverExtension: coverExtension,
                    };
                })
            );
            setFormatCovers(newCovers);
        } catch (e) {
            console.error("decoded image Error:", e);
        }
    }, [props.covers])

    // const formatCoversData = async () => {
    //     if (!props.covers) return;
    //     try {
    //         const newCovers = await Promise.all(
    //             props.covers.map(async (cover: any) => {
    //                 let imgURL = getImageURL(cover);
    //                 const coverTitle = cover.title.split(".");
    //                 let coverExtension = coverTitle[coverTitle.length - 1];
    //                 if (cover?.coverKind === "image" || isImgType(cover?.coverKind))
    //                     imgURL = await getUrl(imgURL, cover.imageID, 1024, "post");
    //                 return {
    //                     coverLink: imgURL,
    //                     coverType: getCoverType(cover?.coverKind),
    //                     rotation:
    //                         cover?.coverKind === "image" || isImgType(cover?.coverKind)
    //                             ? await checkRotation(imgURL)
    //                             : "default",
    //                     imageID: cover.imageID,
    //                     title: cover.title,
    //                     coverKind: cover.coverKind,
    //                     id: cover.id,
    //                     coverExtension: coverExtension,
    //                 };
    //             })
    //         );
    //         setFormatCovers(newCovers);
    //     } catch (e) {
    //         console.error("decoded image Error:", e);
    //     }
    // };

    useEffect(() => {
        if (!props.covers) return;
        formatCoversData();
    }, [props.covers]);

    const isOverflown = useCallback((clientWidth: number, clientHeight: number, scrollWidth: number, scrollHeight: number) => {
        // console.log("clientWidth:", clientWidth, " clientHeight:", clientHeight, " scrollWidth:", scrollWidth, " scrollHeight:", scrollHeight)
        return (scrollWidth > clientWidth || scrollHeight > clientHeight)
    }, [])

    const onReadMore = useCallback(() => {
        setReadMore(!readMore);
    }, [readMore])

    const haveMoreContent = useMemo(() => {
        if (!innerContentRef.current) return false;
        let element = innerContentRef.current;
        return isOverflown(element.clientWidth, element.clientHeight, element.scrollWidth, element.scrollHeight);
    }, [innerContentRef.current])

    // useEffect(() => {
    //     if (!innerContentRef.current) return;
    //
    //     let element = innerContentRef.current;
    //     console.log(element)
    //     let overflow = isOverflown(element.clientWidth, element.clientHeight, element.scrollWidth, element.scrollHeight);
    //     setMoreContent(overflow)
    //     console.log("more content", moreContent)
    // }, [innerContentRef.current])

    // const isLike = useMemo(() => {
    //     return likeUsers.some((item: any) => {
    //         return item.userID === getUserData().id;
    //     });
    // }, [likeUsers])

    const coverSize: number = useMemo(() => {
        return Math.min(formatCovers.length, maxCoverSize)
    }, [formatCovers])

    const covers = useMemo(() => {
        const coverGrid = coversGrid.find((cov) => cov.size === coverSize);
        if (!coverGrid) return [];

        return formatCovers.map((cov: any, index: number) => {
            if (index < coverSize) {
                return {
                    id: index,
                    src: cov.coverLink,
                    type: cov.coverKind,
                    width: coverGrid.grid[index].width,
                    height: coverGrid.grid[index].height,
                    style: coverGrid.grid[index]?.style
                }
            } else {
                return {
                    id: index,
                    src: cov.coverLink,
                    type: cov.coverKind,
                }
            }
        })
    }, [formatCovers, coverSize])

    const columns = useMemo(() => {
        const coverGrid = coversGrid.find((cov) => cov.size === coverSize);
        if (!coverGrid) return 1;

        return coverGrid.columns
    }, [formatCovers, coverSize])

    const handleLike = useCallback(async () => {
        await likeAPI.put(`/${props.id}`);
        if (likeAPI.response.ok) {
            setIsLike(true);
            const newPeopleLike = [...likeUsers];
            // if (newPeopleLike.length < 3) {
            //     newPeopleLike.push(getUserData());
            // } else {
            //     newPeopleLike[0] = getUserData();
            // }
            newPeopleLike.push(getUserData());
            setLikeUsers(newPeopleLike);
        }
    }, [isLike, likeUsers])

    const handleUnlike = useCallback(async () => {
        await likeAPI.delete(`/${props.id}`);
        if (likeAPI.response.ok) {
            setIsLike(false);
            const newPeopleLike = likeUsers.filter((person: any) => {
                return person.id !== getUserData().id;
            });

            setLikeUsers(newPeopleLike);
        }
    }, [isLike, likeUsers])

    // const handleLike = async () => {
    //     await likeAPI.put(`/${props.id}`);
    //     if (likeAPI.response.ok) {
    //         setIsLike(true);
    //         const newPeopleLike = [...likeUsers];
    //         if (newPeopleLike.length < 3) {
    //             newPeopleLike.push(getUserData());
    //         } else {
    //             newPeopleLike[0] = getUserData();
    //         }
    //         setLikeUsers(newPeopleLike);
    //     }
    // };

    // const handleUnlike = async () => {
    //     await likeAPI.delete(`/${props.id}`);
    //     if (likeAPI.response.ok) {
    //         setIsLike(false);
    //         const newPeopleLike = likeUsers.filter((person: any) => {
    //             return person.id !== getUserData().id;
    //         });
    //
    //         setLikeUsers(newPeopleLike);
    //     }
    // };

    const toggleLike = useCallback(async () => {
        if (isLike) {
            await handleUnlike()
        } else {
            await handleLike()
        }
    }, [isLike, likeUsers])


    useEffect(() => {
        setLikeUsers(getPreviewPeopleLike);
    }, [props.likes])

    const renderContent = useMemo(() => {
        if (!props.content) return null
        const options = {
            target: "_blank",
        };
        return <div dangerouslySetInnerHTML={{__html: linkifyHtml(props.content, options)}}/>
    }, [props.content])

    const renderLikeButton = useMemo(() => {
        return (
            <Fragment>
                {
                    isLike &&
                    <Lottie
                        animationData={heartLogo}
                        autoplay={true}
                        loop={false}
                        initialSegment={[prevIsLike === undefined ? 36 : 0, 36]}
                        style={{width: 40, height: 40, pointerEvents: "none"}}
                    />
                }
                {!isLike &&
                    <Lottie
                        animationData={heartLogo}
                        autoplay={true}
                        loop={false}
                        initialSegment={[0, 1]}
                        style={{width: 40, height: 40, pointerEvents: "none"}}
                    />
                }
            </Fragment>
        )
    }, [isLike])

    const renderFavoriteButton = useMemo(() => {
        return (
            <Fragment>
                {
                    isPin &&
                    <Lottie
                        animationData={bookMarkAnimate}
                        autoplay={true}
                        loop={false}
                        initialSegment={[prevIsPin === undefined ? 30 : 0, 30]}
                        style={{width: 40, height: 40, pointerEvents: "none"}}
                    />
                }
                {!isPin &&
                    <Lottie
                        animationData={bookMarkAnimate}
                        autoplay={true}
                        loop={false}
                        initialSegment={[0, 1]}
                        style={{width: 40, height: 40, pointerEvents: "none"}}
                    />
                }
            </Fragment>
        )
    }, [isPin])

    const renderPinButton = useMemo(() => {
        return (
            <Fragment>
                {
                    isPaperPin &&
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                         className="bi bi-pin-fill"
                         style={{color: "rgb(8,87, 160)"}}
                         viewBox="0 0 16 16">
                        <path
                            d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A5.921 5.921 0 0 1 5 6.708V2.277a2.77 2.77 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354z"/>
                    </svg>
                }
                {!isPaperPin &&
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                         className="bi bi-pin"
                         style={{fontSize: "10rem", color: "rgb(147,157,166)"}}
                         viewBox="0 0 16 16">
                        <path
                            d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A5.921 5.921 0 0 1 5 6.708V2.277a2.77 2.77 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354zm1.58 1.408-.002-.001.002.001zm-.002-.001.002.001A.5.5 0 0 1 6 2v5a.5.5 0 0 1-.276.447h-.002l-.012.007-.054.03a4.922 4.922 0 0 0-.827.58c-.318.278-.585.596-.725.936h7.792c-.14-.34-.407-.658-.725-.936a4.915 4.915 0 0 0-.881-.61l-.012-.006h-.002A.5.5 0 0 1 10 7V2a.5.5 0 0 1 .295-.458 1.775 1.775 0 0 0 .351-.271c.08-.08.155-.17.214-.271H5.14c.06.1.133.191.214.271a1.78 1.78 0 0 0 .37.282z"/>
                    </svg>
                }
            </Fragment>
        )
    }, [isPaperPin])

    const contentStyle = useMemo(() => {
        if (!props.contentStyle) return;
        let style = JSON.parse(props?.contentStyle);
        if (style.backgroundColor === "#fff") {
            style.backgroundColor = null;
        }
        return style;
    }, [props.contentStyle]);

    const renderLikeUsers = useMemo(() => {
        // console.log("likeUsers", likeUsers)
        // const data = likeUsers.map((user: any) => {
        //     return {
        //         key: user.id,
        //         name: user.firstname,
        //         src: user?.imageProfileURL
        //     }
        // })
        return (
            <Avatar.Group
                maxCount={3}
                size="small"
                maxStyle={{ color: '#f56a00', backgroundColor: '#fde3cf' }}
            >
                {
                    likeUsers.map((user: any) => {
                        return (
                            <ProfilePopover userId={user.id} imgURL={user?.imageProfileURL} name={user?.firstname +
                                (_.isEmpty(user?.lastname)
                                    ? ""
                                    : " " + user?.lastname)}>
                                <Avatar style={{ cursor: "pointer" }} src={user?.imageProfileURL} />
                            </ProfilePopover>)
                    })
                }

            </Avatar.Group>
        )

        // return <AvatarGroup size="small" appearance="stack" data={data}/>;
    }, [likeUsers])

    const getFullName = useCallback((user: any) => {
        if (user?.id === getUserData()?.id) return "you";
        const fullName =
            user?.firstname + (user?.lastname ? " " + user?.lastname : "");

        if (fullName.length > 30) return fullName.substring(0, 27) + "...";

        return fullName;
    }, []);

    const handleFavorite = useCallback(async () => {
        if (isPin) {
            await handleUnFavoritePost()
        } else {
            await handleFavoritePost()
        }
    }, [isPin])

    const handleFavoritePost = useCallback(async () => {
        await favAPI.put(`/${props.id}`);
        if (favAPI.response.ok) {
            setIsPin(true);
        }
    }, [])

    const handleUnFavoritePost = useCallback(async () => {
        await favAPI.delete(`/${props.id}`);
        if (favAPI.response.ok) {
            setIsPin(false);
        }
    }, [])

    const handlePaperPin = useCallback(async () => {
        if(!props.canUsePin) return
        if (isPaperPin) {
            await handleUnPaperPinPost()
        } else {
            await handlePaperPinPost()
        }
    }, [isPaperPin])

    const handlePaperPinPost = useCallback(async () => {
        // console.log("props.params", props.params, props.params?.hasOwnProperty('groupID'))
        // if (!props.params?.hasOwnProperty('groupID')) return

        await paperPinAPI.post(`/${props.id}`, {
            refID: (props.params?.groupID) ? props.params?.groupID : getUserData().id,
            pinType: (props.isPinType) ? "group" : "user"
        });

        if (paperPinAPI.response.ok) {
            setIsPaperPin(true);
        }
    }, [])

    const handleUnPaperPinPost = useCallback(async () => {
        // const param = props.params?.find((keys: any) => {
        //     console.log("key", keys);
        //     return keys.key === "groupID";
        // })
        let ref = (props.params?.groupID) ? props.params?.groupID : getUserData().id;
        let isPinType = (props.isPinType) ? "group" : "user";
        await paperPinAPI.delete(`/${props.id}/${ref}/${isPinType}`);
        if (paperPinAPI.response.ok) {
            setIsPaperPin(false);
        }
    }, [])


    const handleEditPost = () => {
        const privacy = allPrivacyOption.find((option: any) => {
            return option.value === props.privacy;
        });

        let oldMentions;
        let thisGroupMentionID: any = null;

        if (location.pathname === "/group-community") {
            const queryString = new URLSearchParams(location.search);
            const groupID = queryString.get("id");

            const thisGroupMen = props.mentions.find((mention: any) => {
                return mention?.group?.id === groupID;
            });

            if (thisGroupMen) thisGroupMentionID = thisGroupMen;

            oldMentions = props.mentions.filter((mention: any) => {
                if (mention.type === "user") return true;
                if (mention.type === "group") return mention?.group?.id !== groupID;
            });
        } else {
            oldMentions = props.mentions ? props.mentions : [];
        }

        const mentions =
            oldMentions.length !== 0
                ? oldMentions.map((mention: any) => {
                    let label;
                    let id;

                    if (mention.type === "user") {
                        label =
                            mention?.user?.firstname +
                            " " +
                            (mention?.user?.lastname || "");
                        id = mention?.user?.id;
                    } else if (mention.type === "group") {
                        label = mention?.group?.name;
                        id = mention?.group?.id;
                    }

                    return {
                        label: label,
                        mentionID: id,
                        type: mention.type,
                        value: id,
                        id: mention.id,
                        user: mention.user,
                    };
                })
                : [];

        let categories;
        if (props?.categories) {
            categories = props?.categories?.map((category: any) => {
                return {
                    label: category.categoryName,
                    categoryID: category.categoryID,
                    name: category.categoryName,
                    value: category.categoryName,
                    id: category.id,
                };
            });
        } else {
            categories = [];
        }

        const newFormatCovers = formatCovers ? [...formatCovers] : [];

        const oldData = {
            covers: newFormatCovers,
            mentions: [...mentions],
            categories: [...categories],
            groupMention: thisGroupMentionID,
        };

        props.onEditPost({
            feedId: props.id,
            title: props.title,
            content: props.content,
            privacyOption: privacy,
            oldData: Object.assign({}, oldData),
            oldCover: Object.assign([], newFormatCovers),
            captionStyle: props?.contentStyle ? JSON.parse(props.contentStyle) : null,
            previewCovers: newFormatCovers,
            tag: [...mentions],
            categories: [...categories],
        })

    };

    const handleDeletePost = async () => {
        deleteMutation.mutate(props.id);
        // try {
        //     await deleteFeedAPI.delete();
        //     if (deleteFeedAPI.response.ok) {
        //         setShowDeletePostModal(false);
        //         props.onDelete(props.id)
        //     }
        // } catch (e) {
        //     console.error(e);
        // }
    };

    const handleClickProfile = useCallback(() => {
        props.onOpenOwnerProfile(props.ownerId)
    }, [])

    return (
        <Card
            style={{
                width: '100%',
                border: "1px solid #E7E6E6",
                borderRadius: "12px"
            }}

            title={
                <div className={styles.TitleContainer}>
                    <ProfilePopover userId={props.ownerId} imgURL={props.avatarURL} name={props.name}>
                        <div
                            className={styles.AvatarContainer}
                            onClick={handleClickProfile}
                        >
                            <Avatar src={props.avatarURL} size={40}/>

                        </div>
                    </ProfilePopover>
                    <div className={styles.TitleDetailContainer}>
                        <div className={styles.TitleDetailCon}>
                            <span className={styles.TitleName} onClick={handleClickProfile}>{props.name}</span>
                            <span className={styles.TitleDescription}>{postTime}</span>
                        </div>
                        <div
                            className={styles.ListTailContainer}
                        >
                            {(props.canUsePin || isPaperPin) && (
                                <div onClick={handlePaperPin} style={{ cursor: (props.canUsePin) ? "pointer" : '', textAlign: "center" }}>
                                    {renderPinButton}
                                </div>)
                            }

                            <div onClick={handleFavorite} style={{cursor: "pointer", width: 40, height: 40}}>
                                {renderFavoriteButton}
                            </div>
                            {/*<MoreOutlined style={{fontSize: '18px', cursor: "pointer"}}/>*/}
                            <div style={{
                                // zIndex: 1,
                                // position: "relative",
                                display: "flex",
                                // justifyContent: "center",
                                // alignItems: "center"
                            }}
                            >
                                <Dropdown
                                    overlay={
                                        <Menu>
                                            {props.owner === getUserData()?.username && (
                                                <Menu.Item
                                                    className={styles.menuItem}
                                                    onClick={handleEditPost}
                                                >
                                                    <div style={{display: "flex"}}>
                                                        <div style={{width: 25}}>
                                                            <img
                                                                src={editImg}
                                                                width="20"
                                                                style={{cursor: "pointer", marginBottom: "2px"}}
                                                            />
                                                        </div>
                                                        <div
                                                            style={{
                                                                margin: "auto",
                                                                marginLeft: "10px",
                                                            }}
                                                        >
                                                            {t("Edit post")}
                                                        </div>
                                                    </div>
                                                </Menu.Item>
                                            )}

                                            {props.owner === getUserData()?.username && (
                                                <Menu.Item
                                                    className={styles.menuItem}
                                                    onClick={() => {
                                                        setShowDeletePostModal(true);
                                                    }}
                                                >
                                                    <div style={{display: "flex"}}>
                                                        <div style={{width: 25}}>
                                                            <img
                                                                src={deleteImg}
                                                                width="20"
                                                                style={{cursor: "pointer", marginBottom: "2px"}}
                                                            />
                                                        </div>
                                                        <div
                                                            style={{
                                                                margin: "auto",
                                                                marginLeft: "10px",
                                                            }}
                                                        >
                                                            {t("Delete post")}
                                                        </div>
                                                    </div>
                                                </Menu.Item>
                                            )}
                                            {props.owner !== getUserData()?.username && (
                                                <Menu.Item
                                                    className={styles.menuItem}
                                                    onClick={() => {
                                                        setShowReportModal(true);
                                                    }}
                                                >
                                                    <div style={{display: "flex"}}>
                                                        <div style={{width: 25}}>
                                                            <img
                                                                src={exclamationImg}
                                                                width="20"
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                        <div
                                                            style={{
                                                                margin: "auto",
                                                                marginLeft: "10px",
                                                            }}
                                                        >
                                                            {t("Report post")}
                                                        </div>
                                                    </div>
                                                </Menu.Item>
                                            )}
                                        </Menu>
                                    }
                                    getPopupContainer={(triggerNode: HTMLElement) =>
                                        (triggerNode?.parentNode as HTMLElement) || document.body
                                    }
                                    // placement="bottomCenter"
                                    arrow
                                    trigger={["click"]}
                                >
                                    <MoreOutlined style={{fontSize: '18px', cursor: "pointer"}}/>
                                </Dropdown>
                            </div>

                        </div>
                    </div>
                </div>
            }
            headStyle={{
                borderBottom: 0,
                // padding: "0 0 0 0",
            }}
            bodyStyle={{
                margin: 0,
                padding: 0
            }}
            // extra={
            //
            // }
            // style={{ width: 300 }}
        >
            <CenterConfirmModal
                visible={showDeletePostModal}
                onCancel={() => {
                    setShowDeletePostModal(false);
                }}
                confirmLoading={deleteMutation.isLoading}
                onConfirm={handleDeletePost}
                text={t("Are you sure to delete this post?")}
                confirmText={t("OK")}
                cancelText={t("Cancel")}
            />

            {props.title &&
                <Fragment>
                    {
                        titleLink.linkMatchArray ? (
                            <div className={styles.CardTitle} onClick={() => {
                            }}>
                                <AutoLinkText
                                    text={props.title}
                                    linkProps={{
                                        target: "_blank",
                                    }}
                                />
                            </div>
                        ) : (
                            <div className={styles.CardTitle}>{props.title}</div>
                        )
                    }
                </Fragment>
            }
            <div className={styles.CardBody}>
                {!_.isEmpty(props.mentions) && (
                    <div className={styles.tagContainer}>
                        <TagOutlined style={{fontSize: '22px', color: `rgb(165, 165, 165)`}}/>
                        {/*<div*/}
                        {/*    className={styles.tagIcon}*/}
                        {/*    style={{*/}
                        {/*        backgroundImage: `url(${iconTag})`,*/}
                        {/*        marginRight: "10px",*/}
                        {/*        marginTop: 10,*/}
                        {/*    }}*/}
                        {/*/>*/}
                        <div className={styles.tagname}>{getTagString(props.mentions)}</div>
                    </div>
                )}
                {covers && covers.length > 0 && (
                    <div style={{marginBottom: "1.5rem"}}>
                        <CoverPreviewContainer
                            covers={covers}
                            columns={columns}
                            maxSize={coverSize}
                            // styles={coversGrid.find((cov) => cov.size === formatCovers.length)?.styles}
                        />
                    </div>
                )}
                {_.isEmpty(props.covers) &&
                    <Fragment>
                        {titleLink.graphDetail &&
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    // marginTop: 10,
                                    marginBottom: "1.5rem",
                                }}
                            >
                                <PreviewPostLink
                                    graphDetail={titleLink.graphDetail}
                                    url={titleLink.graphDetail?.url || titleLink.graphDetail?.realUrl || titleLink.url}
                                />
                            </div>
                        }
                        {!titleLink.graphDetail && contentLink.graphDetail &&
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    // marginTop: 10,
                                    marginBottom: "1.5rem",
                                }}
                            >
                                <PreviewPostLink
                                    graphDetail={contentLink.graphDetail}
                                    url={contentLink.graphDetail?.url || contentLink.graphDetail?.realUrl || contentLink.url}
                                />
                            </div>
                        }
                    </Fragment>
                }
                {props.content &&
                    <div
                        className={styles.ContentWrapper}
                        style={{
                            backgroundColor: contentStyle?.backgroundColor,
                            padding: contentStyle?.backgroundColor ? "2em 1em 1em 1em" : 0
                        }}
                    >
                        <div
                            ref={innerContentRef}
                            style={contentStyle}
                            className={readMore ? styles.InnerContentFull : styles.InnerContent}
                        >
                            {renderContent}
                            {/*<div dangerouslySetInnerHTML={{__html: linkifyHtml(props.content)}}/>*/}
                        </div>
                        {haveMoreContent &&
                            <div>
                                <span
                                    className={styles.ReadMore}
                                    onClick={onReadMore}
                                >
                                    {readMore ? t("show less") : t("read more")}
                                </span>
                            </div>
                        }
                    </div>

                }
                <div className={styles.LikePanel}>
                    <div className="heart-btn"
                         style={{
                             width: 40,
                             height: 40,
                             marginLeft: "-9px",
                             cursor: "pointer"
                         }}
                         onClick={toggleLike}
                    >
                        {renderLikeButton}
                    </div>
                    {renderLikeUsers}
                    {likeUsers.length > 0 && (
                        <div style={{paddingLeft: ".25rem", paddingRight: ".25rem", display: "inline-flex"}}>
                            <div
                                style={{
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                    overflow: " hidden",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {t("Like by")} {isLike ? t("you") : getFullName(likeUsers[0])}{" "}
                                {likeUsers.length > 1 && (
                                    <span>
                                        {t("and")} {`${likeUsers.length - 1} `}
                                        {t("others")}
                                    </span>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                {props.categories && (
                    <div className={styles.categoryContainer}>
                        <div className={styles.categoryLabel}>{t("Category")}</div>
                        {props.categories.map((category: any, idx: number) => {
                            return (
                                <div className={styles.category} key={idx}>
                                    {category?.categoryName}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            <div className={styles.CardFooter} onClick={handleClickFooter}>
                <CommentOutlined style={{fontSize: '22px', color: `rgb(165, 165, 165)`}}/>
                <span style={{marginLeft: ".5rem"}}>{t("Comment") + ` (${props.totalComments})`}</span>
            </div>
            {/*<ProfileModal*/}
            {/*    visible={showProfileModal}*/}
            {/*    userId={props.ownerId}*/}
            {/*    onRefresh={() => {}}*/}
            {/*    onClose={() => setShowProfileModal(false)}*/}
            {/*/>*/}
            <UIModalReportPost
                onClose={() => {
                    setShowReportModal(false);
                }}
                id={props.id}
                show={showReportModal}
            ></UIModalReportPost>
            {/*<CommentsDrawer*/}
            {/*    feedId={props.id}*/}
            {/*    open={openComments}*/}
            {/*    onClose={() => {*/}
            {/*        setOpenComments(false)*/}
            {/*        // setCurrentFeedId(undefined)*/}
            {/*    }}*/}
            {/*/>*/}
        </Card>
    )
}

// export default React.memo(FeedCard)